// extracted by mini-css-extract-plugin
export var blue = "_d-f";
export var brand = "_d-b";
export var darkGrey = "_d-e";
export var disabled = "_d-4";
export var disabledSubtle = "_d-5";
export var error = "_d-6";
export var green = "_d-g";
export var grey = "_d-d";
export var icon = "_d-0";
export var inherit = "_d-a";
export var lightGrey = "_d-c";
export var orange = "_d-i";
export var pink = "_d-k";
export var primary = "_d-1";
export var purple = "_d-l";
export var red = "_d-j";
export var secondary = "_d-2";
export var success = "_d-9";
export var tertiary = "_d-3";
export var warning = "_d-7";
export var warningSecondary = "_d-8";
export var white = "_d-m";
export var yellow = "_d-h";